<script setup>
import {ref} from "vue"
import {router, usePage} from "@inertiajs/vue3"
import CDialog from "@/Components/CDialog.vue"
import PCartItemsList from "@/Pages/Cart/Partials/PCartItemsList.vue"

const page = usePage()
const dialog = ref()
const drawer = defineModel()
const props = defineProps({})
const checkoutModal = ref(false)

const checkout = function () {
    router.get(
        route('cart.checkout'),
        {},
        {
            preserveState: true,
            onSuccess: () => {
                drawer.value = false
            },
        }
    )
}
</script>

<template>
    <v-navigation-drawer
        v-model="drawer"
        temporary
        :location="$vuetify.display.mobile ? 'bottom' : 'right'"
        :width="$vuetify.display.mobile ? null : 600"
        :height="$vuetify.display.mobile ? '50%' : null">
        <p-cart-items-list v-model="drawer"/>
    </v-navigation-drawer>
    <c-dialog ref="dialog"/>
</template>

